import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserId } from "src/app/interfaces";
import { LogClass } from "src/app/logger";
import { UserFacade } from "src/app/user/services/user.facade";

@LogClass({ source: "Substitute view" })
@Component({
    selector: "substitute-user-view",
    templateUrl: "./user-view.component.html",
    standalone: false
})
export class UserViewComponent implements OnInit {
  public userId: Observable<UserId>;

  constructor(private userFacade: UserFacade) {}

  ngOnInit(): void {
    this.userId = this.userFacade.getUser().pipe(map((u) => u.id));
  }
}
